// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import api from '../../../common/api';
import alert from '../../../share/alert';
import config from '../../../share/config';
import cstmTable from '../../../share/components/vue/PaginationTable';
import loading from '../../../share/components/vue/ProcessingIcon';
import individualDiagnose from '../../../share/util/individualDiagnose';
import diagnoResource from '../../../share/util/diagnose';
import resource from '../../../share/util/resourceMap';
import logWrapper from '../../../share/logWrapper';
import util from '../../../share/util/utils';
import ffdModal from '../../vue/FFDModalCancelCode';
import memoPage from '../../vue/MemoPage';
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';
import { REQUEST_STATUS_IN_PROGRESS, REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/src/util/api/polling';
import { CNC } from "../../../constants/usageCountTypes";
import DiagSystemUtils from '../../../common/nodejs/diagSystemUtils';
import ApiService from '../../../share/util/api/service';
import { getMeasuredDataName, getCsvFileName } from '../../../util/fileExport';
import { getAbbrSysName } from '../../../share/util/systemName';
import { isAdas2CancelCode } from '../../organisms/individualCancelCode/CancelCodeUtil';
const buttonFontSizeOther = "button-font-size-other";

export default {
  name: 'IndividualCancelCodeResult',
  data() {
    return {
      systemId: undefined,
      projectId: undefined,
      measuredId: undefined,
      processing: false,
      processingCruiseSW: false,
      getCancelCodeResultResponse: undefined,
      resultResponse: undefined,
      testModeVisible: false,
      cancelCodeResultItems: [],
      cancelCodeResultColumns: [],
      selectedCancelCode: undefined,
      modalTitle: '',
      ffdSystem: '',
      ffdDescription: '',
      ffdTableItems: [],

      modalFfd: false,
      modalMemo: false,
      modalCruise: false,
      isMemoDialogLoading: false,

      // ES独自処理用
      systemES: {
        pullDownList: [],
        selectedId: undefined,
        resultES: [],
        i18nCncESKey: '',
        isExec: true,
        isActiveDropdown: true
      },
      // ADAS独自処理用
      systemADAS: {
        pullDownList: [],
        selectedId: undefined,
        resultADAS: [],
        i18nCncADASKey: '',
        isExec: true,
        isActiveDropdown: true
      }
    };
  },

  props: {
    i18nCncKey: { type: String, default: '', required: true },
    cancelCodeId: { type: Number, default: '', required: true },
    functionList: { type: Array, default: [], required: false },
  },

  components: {
    'processing-view': loading,
    'processing-view-cruiseSW': loading,
    'cstm-table': cstmTable,
    'ffd-modal': ffdModal,
    'memo-page': memoPage,
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      netAppId: state => state.netAppConnector.pairingAppId,
      cachedFFDs: state => state.cache.ffdStores,
      isPopstateNavigation: state => state.cache.isPopstateNavigation,
    }),

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    },

    /** 再取得ボタンのフォントサイズを判定 */
    checkButtonClassReGetDetail() {
      switch (this.$parent.$i18n.locale) {
        case "fr":
          return buttonFontSizeOther;
        default:
          return "";
      }
    },
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        if (!this.resultResponse) {
          return;
        }

        if (DiagSystemUtils.isTransmissionByAbbreviationId(getAbbrSysName(this.systemId))) {
          this.updateTableTM();
          this.updateColumns();
          return;
        }
        if (DiagSystemUtils.isReverseBrakeAssistByAbbreviationId(getAbbrSysName(this.systemId))) { 
          this.updateTableRAB();
          this.updateColumnsRAB();
          return;
        }
        if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId))) {
          // ESの時はプルダウンも更新をする
          this.systemES.pullDownList = this.getPullDownList(this.functionList, this.systemId);

          this.updateTableES();
          this.updateColumnsES();
          return;
        }
        if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
          // ADASの時はプルダウンも更新をする
          this.systemADAS.pullDownList = this.getPullDownList(this.functionList, this.systemId);

          // ADAS2対象はADAS2用の結果テーブル、それ以外はADAS1用の結果テーブルを表示
          if (isAdas2CancelCode(this.systemADAS.selectedId)) {
            this.updateTableADAS2();
            this.updateColumnsADAS2();
            return;
          } else {
            this.updateTableADAS1();
            this.updateColumnsADAS1();
            return;
          }
        }
        this.updateTable();
        this.updateColumns();
      }
    },

    selectedCancelCode() {
      if (!this.selectedCancelCode) return;

      const data = this.selectedCancelCode;
      const system = this.$t(`diagSytem.${this.systemId}`);
      const status = data.status ? ` (${data.status}) ` : '';
      this.modalTitle = data.code + status;
      this.ffdSystem = `${system}`;
      this.ffdDescription = `${data.description}`;
    }
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      vm.beforeRouteProcess(vm, to, from);
    });
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      this.beforeRouteProcess(this, to, from);
      // テーブル情報クリア（本当は mountedLogic に入れたいが、影響範囲を考慮してここにピンポイントで入れている）
      // FFD キャッシュクリアは、moutedLogic 内でやっているので問題なし
      this.cancelCodeResultItems = [];
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('cache', ['cacheFFDStores', 'cacheIsPopstateNavigation']),
    ...mapActions('observation', ['usageCountUp']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // FFDのキャッシュクリア
      this.cacheFFDStores([]);
      // キャンセルコードテーブルの取得
      if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId))) {
        this.executeES();
      } else if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
        this.executeADAS();
      } else {
        this.execute();
      }

      // debug 環境のみ実施有効とする
      if (process.env.VUE_APP_DEBUG_LOG) {
        // テストボタン表示 
        document.onkeydown = (event) => {
          if (event) {
            // Ctrl+Shift+V key detection
            if (event.shiftKey && event.ctrlKey) {
              if (event.code === "KeyV") {
                this.testModeVisible = true;
                return true;
              }
            }
          }
          return util.checkSSM5ValidCharacters(event);
        };
      }
    },

    closeResult() {
      // FFDのキャッシュクリア
      this.cacheFFDStores([]);
      this.$emit('close-result');
    },

    /**
     * アイサイト判定をテンプレートから参照
     * @param {string} systemId 
     * @returns アイサイト判定
     */
    isEyesight(systemId) {
      return DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(systemId));
    },

    /**
     * 統合ECU判定をテンプレートから参照
     * @param {string} systemId 
     * @returns 統合ECU判定
     */
    isAdasEcu(systemId) {
      return DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(systemId));
    },

    /** ES用の読出し処理 サポートしている全キャンセルコードを読出す */
    async executeES() {
      for (const index of this.functionList) {
        // 実行毎に初期化する
        this.measuredId = undefined;

        // 実行対象機能を切り替える
        await this.execute(index.id); // 読出し実行
        // 異常終了した場合はループを抜ける
        if (!this.systemES.isExec) break;
      }
      // 異常終了したら処理終了
      if (!this.systemES.isExec) return;

      this.updateTableES();
      this.updateColumnsES();
    },

    /** ADAS用の読出し処理 サポートしている全キャンセルコードを読出す */
    async executeADAS() {
      for (const index of this.functionList) {
        // 実行毎に初期化する
        this.measuredId = undefined;

        // 実行対象機能を切り替える
        await this.execute(index.id); // 読出し実行
        // 異常終了した場合はループを抜ける
        if (!this.systemADAS.isExec) break;
      }
      // 異常終了したら処理終了
      if (!this.systemADAS.isExec) return;

      // ADAS2対象はADAS2用の結果テーブル、それ以外はADAS1用の結果テーブルを表示
      if (isAdas2CancelCode(this.systemADAS.selectedId)) {
        this.updateTableADAS2();
        this.updateColumnsADAS2();
        return;
      } else {
        this.updateTableADAS1();
        this.updateColumnsADAS1();
        return;
      }
    },

    /**
     * 情報取得状況の監視がfailed時の処理(ES用)
     * @param {number} id 実行した機能ID
     * */
    responseFailedES(id) {
      // 通信不能を表示させるため、res_type: NGをセットする
      const tmpResultES = {
        id: id, //実行したcncID
        readResult: {
          res_type: config.CNC_RESPONSE_TYPE_NG,
          current_igon_time: null,
          measuredId: this.measuredId
        }
      };

      // 結果用配列に詰める
      this.systemES.resultES.push(tmpResultES);
    },

    /**
     * 情報取得状況の監視がfailed時の処理(ADAS用)
     * @param {number} id 実行した機能ID
     * */
    responseFailedADAS(id) {
      // 通信不能を表示させるため、res_type: NGをセットする
      const tmpResultADAS = {
        id: id, //実行したcncID
        readResult: {
          res_type: config.CNC_RESPONSE_TYPE_NG,
          current_igon_time: null,
          measuredId: this.measuredId
        }
      };

      // 結果用配列に詰める
      this.systemADAS.resultADAS.push(tmpResultADAS);
    },

    /**
     * データ読み出し
     * @param {number} [cncId=this.cancelCodeId] 実行する機能ID, ES,ADAS以外は一覧画面にて選択された機能ID
     * */
    async execute(cncId = this.cancelCodeId) {
      try {
        this.processing = true;
        let failedFlg = false;
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        const response = await individualDiagnose.pollingApi(
          this,
          // キャンセルコード情報取得結果(要求)(POST API) 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CNC,
              '/netApps/' + this.netAppId + '/systems/' + this.systemId + '/cancelCodes/' + cncId
            );
          },
          // キャンセルコード情報取得状況の監視(GET API) 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.CNC,
              '/netApps/' + this.netAppId + '/systems/' + this.systemId + '/cancelCodes/' + cncId + '/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case REQUEST_STATUS_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  this.measuredId = getApiResponse.data.measured_id.toString();
                  break;
                case REQUEST_STATUS_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case REQUEST_STATUS_FAILED:
                  if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId)) || DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
                    // ES,ADASの場合はエラーを表示しない
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                    failedFlg = true;
                  }
                  // ES,ADAS以外の場合はエラー表示
                  break;
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          async (result) => { await this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          async (result) => { await this.validateErrorResult(result); },
          // リトライ回数とリトライ待機時間を指定
          process.env.VUE_APP_CANCEL_CODE_RETRY_COUNT,
          process.env.VUE_APP_CANCEL_CODE_RETRY_INTERVAL,
          // ポーリング時のタイムアウト停止フラグを有効化
          true,
        );

        if (response) {
          // キャンセルコード各機能の利用回数カウントアップ（正常・異常問わず取得API実行後にカウントアップ）
          this.usageCountUp({ type: CNC, systemName: this.systemId, immutableId: cncId });

          if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId)) && failedFlg) {
            // ESの場合はステータス「通信不能」を表示させ、後続処理は実施しない
            await this.responseFailedES(cncId);
            return;
          }

          if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId)) && failedFlg) {
            // ADASの場合はステータス「通信不能」を表示させ、後続処理は実施しない
            await this.responseFailedADAS(cncId);
            return;
          }

          // ポーリングが正常に完了した場合は、キャンセルコード情報取得結果を行う
          this.getCancelCodeResultResponse = await this.getCancelCodeResult();
          // responseが存在しない場合、処理終了
          if (!this.getCancelCodeResultResponse) {
            return;
          }

          this.resultResponse = this.getCancelCodeResultResponse;

          if (DiagSystemUtils.isTransmissionByAbbreviationId(getAbbrSysName(this.systemId))) {
            this.updateTableTM();
            this.updateColumns();
            return;
          }
          if (DiagSystemUtils.isReverseBrakeAssistByAbbreviationId(getAbbrSysName(this.systemId))) {
            this.updateTableRAB();
            this.updateColumnsRAB();
            return;
          }
          if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId))) {
            // 結果と実行したキャンセルコードIDを紐づける
            const tmpResultES = {
              id: cncId, //実行したcncID
              readResult: this.resultResponse, // 読出し結果
              measuredId: this.measuredId // measuredId
            };

            // 結果用配列に詰める
            this.systemES.resultES.push(tmpResultES);
            return;
          }
          if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
            // 結果と実行したキャンセルコードIDを紐づける
            const tmpResultADAS = {
              id: cncId, //実行したcncID
              readResult: this.resultResponse, // 読出し結果
              measuredId: this.measuredId // measuredId
            };

            // 結果用配列に詰める
            this.systemADAS.resultADAS.push(tmpResultADAS);
            return;
          }
          this.updateTable();
          this.updateColumns();
        }
      } finally {
        this.processing = false;
      }
    },

    // キャンセルコード情報取得結果
    async getCancelCodeResult() {
      const response = await individualDiagnose.syncApi(
        this,
        // GET API 呼び出しのコールバック
        async () => {
          return await api.getCall(
            config.CNC,
            '/cancelCodes/' + this.projectId + '/' + this.measuredId,
            this.operationScreen
          );
        },

        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          // project が入っていれば成功とする
          return getApiResponse && getApiResponse.data && getApiResponse.data.project ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
        },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        async (result) => { await this.validateErrorResult(result); },
      );
      // 処理失敗時は response が null になるので考慮
      return response ? response.data.project : null;
    },

    /**
     * テーブル情報を更新する
     */
    updateTable() {
      this.cancelCodeResultItems = [];
      switch (this.resultResponse.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTable(this.resultResponse.data, this, this.i18nCncKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTable(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブル情報を更新する(TM)
     */
    updateTableTM() {
      this.cancelCodeResultItems = [];
      switch (this.resultResponse.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTableTM(this.resultResponse.data, this, this.i18nCncKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTable(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブル情報を更新する(RAB)
     */
    updateTableRAB() {
      this.cancelCodeResultItems = [];
      switch (this.resultResponse.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTableRAB(this.resultResponse.data, this, this.i18nCncKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTableRAB(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブル情報を更新する(ES)
     */
    updateTableES() {
      this.cancelCodeResultItems = [];
      // 選択したIDの結果を取得する
      const selectedData = this.systemES.resultES.find(e => e.id === this.systemES.selectedId).readResult;
      switch (selectedData.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          // キャンセルコード一覧用のi18nKeyの取得
          this.systemES.i18nCncESKey = `cnc${this.systemId}.${this.systemES.selectedId}`;

          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTableES(selectedData.data, this, this.systemES.i18nCncESKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTableES(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブル情報を更新する(ADAS1)
     */
    updateTableADAS1() {
      this.cancelCodeResultItems = [];
      // 選択したIDの結果を取得する
      const selectedData = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).readResult;
      switch (selectedData.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          // キャンセルコード一覧用のi18nKeyの取得
          this.systemADAS.i18nCncADASKey = `cnc${this.systemId}.${this.systemADAS.selectedId}`;

          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTableADAS1(selectedData.data, this, this.systemADAS.i18nCncADASKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTableADAS1(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブル情報を更新する(ADAS2)
     */
    updateTableADAS2() {
      this.cancelCodeResultItems = [];
      // 選択したIDの結果を取得する
      const selectedData = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).readResult;
      switch (selectedData.res_type) {
        case config.CNC_RESPONSE_TYPE_OK:
          // キャンセルコード一覧用のi18nKeyの取得
          this.systemADAS.i18nCncADASKey = `cnc${this.systemId}.${this.systemADAS.selectedId}`;

          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createCancelCodeResultTableADAS2(selectedData.data, this, this.systemADAS.i18nCncADASKey));
          break;
        case config.CNC_RESPONSE_TYPE_NG:
        case config.CNC_RESPONSE_TYPE_NO:
          this.cancelCodeResultItems = this.cancelCodeResultItems.concat(resource.createEmptyCancelCodeResultTableADAS2(this));
          break;
        default:
          break;
      }
    },

    /**
     * テーブルヘッダーを作り直す
     */
    updateColumns: function () {
      if (!this.resultResponse) return;

      const igonCntVar = util.mkHeaderValue(this.resultResponse.current_igon_time);
      const igonCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igonCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonCntVar;
      const igonTimeVar = util.mkHeaderValue(this.resultResponse.current_igon_mill_sec);
      const igonTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igonTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonTimeVar;
      this.cancelCodeResultColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortStatus },
        { name: 'code', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'individual.label_cnc_description_reason', originalSortFunc: this.sortDescription },
        { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
        { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
      ];
    },

    /**
     * テーブルヘッダーを作り直す(RAB)
     */
    updateColumnsRAB: function () {
      if (!this.resultResponse) return;

      const igonCntVar = util.mkHeaderValue(this.resultResponse.current_igon_time);
      const igonCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igonCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonCntVar;
      const igonTimeVar = util.mkHeaderValue(this.resultResponse.current_igon_mill_sec);
      const igonTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igonTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonTimeVar;
      const absoTimeVar = util.mkHeaderValue(util.convertLocalDateTime(this.resultResponse.current_absolute_time));
      const absoTime = this.$t('individual.label_cnc_absolute_time');
      const absoTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + absoTimeVar;
      this.cancelCodeResultColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortStatus },
        { name: 'code', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'individual.label_cnc_description_reason', originalSortFunc: this.sortDescription },
        { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
        { name: 'absoluteTime', label: util.setColums(absoTime, absoTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortDate },
        { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
      ];
    },

    /**
     * テーブルヘッダーを作り直す(ES)
     */
    updateColumnsES: function () {
      const esData = this.systemES.resultES.find(e => e.id === this.systemES.selectedId).readResult;
      if (!esData) return;

      const igCntVar = util.mkHeaderValue(esData.current_igon_time);
      const igCnt = this.$t('message.header_vehicle_dtc_table_igcounter');
      const igCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igCntVar;
      this.cancelCodeResultColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortStatus },
        { name: 'code', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'individual.label_cnc_description_reason', originalSortFunc: this.sortDescription },
        { name: 'igCounter', label: util.setColums(igCnt, igCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'lksStatus', label: 'individual.label_cnc_lks_status', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'lksMode', label: 'individual.label_cnc_lks_mode', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'occurrenceTime', label: 'individual.label_cnc_occurrence_time', originalSortFunc: diagnoResource.sortDate },
      ];

      // 現在選択しているIDのmeasuredIdを設定 ※キャンセルコード情報取得状況の監視がfailedの際のファイルエクスポート非活性対応
      this.measuredId = this.systemES.resultES.find(e => e.id === this.systemES.selectedId).measuredId;
    },

    /**
     * テーブルヘッダーを作り直す(ADAS1)
     */
    updateColumnsADAS1: function () {
      const adasData = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).readResult;
      if (!adasData) return;

      const igCntVar = util.mkHeaderValue(adasData.current_igon_time);
      const igCnt = this.$t('message.header_vehicle_dtc_table_igcounter');
      const igCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igCntVar;
      this.cancelCodeResultColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortStatus },
        { name: 'code', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'individual.label_cnc_description_reason', originalSortFunc: this.sortDescription },
        { name: 'igCounter', label: util.setColums(igCnt, igCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'lksStatus', label: 'individual.label_cnc_lks_status', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'lksMode', label: 'individual.label_cnc_lks_mode', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'occurrenceTime', label: 'individual.label_cnc_occurrence_time', originalSortFunc: diagnoResource.sortDate },
      ];

      // 現在選択しているIDのmeasuredIdを設定 ※キャンセルコード情報取得状況の監視がfailedの際のファイルエクスポート非活性対応
      this.measuredId = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).measuredId;
    },

    /**
     * テーブルヘッダーを作り直す(ADAS2)
     */
    updateColumnsADAS2: function () {
      const adasData = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).readResult;
      if (!adasData) return;

      const igCntVar = util.mkHeaderValue(adasData.current_igon_time);
      const igCnt = this.$t('message.header_vehicle_dtc_table_igcounter');
      const igCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igCntVar;
      this.cancelCodeResultColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortStatus },
        { name: 'code', label: 'message.header_vehicle_dtc_table_code' },
        { name: 'description', label: 'individual.label_cnc_description_reason', originalSortFunc: this.sortDescription },
        { name: 'igCounter', label: util.setColums(igCnt, igCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'lksStatus', label: 'individual.label_cnc_lks_status', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'accControlAccelerationStatus', label: 'individual.label_cnc_acc_control_acceleration_state', originalSortFunc: diagnoResource.sortFuncItems },
        { name: 'occurrenceTime', label: 'individual.label_cnc_occurrence_time', originalSortFunc: diagnoResource.sortDate },
      ];

      // 現在選択しているIDのmeasuredIdを設定 ※キャンセルコード情報取得状況の監視がfailedの際のファイルエクスポート非活性対応
      this.measuredId = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).measuredId;
    },

    /**
     * メモダイアログを表示する
     */
    openNoteModal() {
      // 無効化
      this.modalMemo = true;
    },

    /**
     * メモ情報の保存
     */
    async memoSave() {
      await this.$refs.memo.save();
    },

    /**
     * メモ情報のクリア
     */
    memoClear: function () {
      this.$refs.memo.clear();
    },

    /**
     * メモダイアログを非表示にする
     */
    closeNoteModal() {
      this.modalMemo = false;
    },

    /** 再取得処理 */
    async reGetCancelCodeResult() {
      const messages = this.$t('individual.message_vehicle_cnc_confirm_get_information');
      this.systemES.isExec = true;
      this.systemADAS.isExec = true;
      alert.showConfirmation(this, null,
        messages,
        async () => {
          // キャンセルコードのキャッシュクリア
          this.cacheFFDStores([]);
          // キャンセルコードの取得
          if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId))) {
            this.systemES.isActiveDropdown = true;
            this.systemES.resultES = [];
            await this.executeES();
          } else if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
            this.systemADAS.isActiveDropdown = true;
            this.systemADAS.resultADAS = [];
            await this.executeADAS();
          } else {
            await this.execute();
          }
        });
    },

    /* Start FFD用の関数一覧 */

    /**
     * FFD ボタン押下時の処理を行う
     * @param {object} data 押下したデータ
     * @returns なし
     */
    async clickFFD(data) {
      if (!data) return;
      this.selectedCancelCode = data;

      const cache = this.cachedFFDs.filter(e => e.system === this.systemId && e.no === data.no);
      if (cache.length > 0) {
        // キャッシュ有ならキャッシュ済みデータを表示
        this.ffdTableItems = cache[0].data;
        this.modalFfd = true;
      } else {
        try {
          this.processing = true;
          // FFDデータ取得
          const getFFDResponse = await this.setFfdTableItems(data.no);

          // responseが存在しない場合、処理終了
          if (!getFFDResponse) {
            return;
          }

          // RABの場合は絶対時間をLocalTimeに変換する
          if (DiagSystemUtils.isReverseBrakeAssistByAbbreviationId(getAbbrSysName(this.systemId)) && getFFDResponse[1]) {
            const absoluteTime = util.convertLocalDateTime(getFFDResponse[1].ffd_data[0].value);
            getFFDResponse[1].ffd_data[0].value = absoluteTime;
          }

          // キャッシュの更新
          this.cacheFFDStores([...this.cachedFFDs, { system: this.systemId, no: data.no, data: getFFDResponse }]);

          // FFDダイアログの表示
          this.modalFfd = true;
          this.ffdTableItems = getFFDResponse;
        } finally {
          this.processing = false;
        }
      }
    },

    /**
     * FFDデータを取得する
     * @param {string} no 選択したキャンセルコード
     */
    async setFfdTableItems(no) {
      const response = await individualDiagnose.syncApi(
        this,
        // GET API 呼び出しのコールバック
        async () => {
          return await api.getCall(
            config.CNC,
            '/cancelCodes/' + this.projectId + '/' + this.measuredId + '/ffd/systems/' + this.systemId + '/codes/' + no,
            this.operationScreen
          );
        },

        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          // dataが入っていれば成功とする
          return getApiResponse && getApiResponse.data && getApiResponse.data.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      return response ? response.data.data : null;
    },

    /**
     * FFD詳細モーダルを非表示にする
     */
    closeFfdModal() {
      this.modalFfd = false;
    },

    /* End FFD用の関数一覧 */

    /* Start Cruise SW用の関数一覧 */

    /** CRUISE SWデータ読み出し処理 */
    async cruiseSwExecute() {
      try {
        this.processingCruiseSW = true;
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        const response = await individualDiagnose.pollingApi(
          this,
          // CruiseSW情報取得(要求)(POST API) 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.CNC,
              '/netApps/' + this.netAppId + '/systems/' + this.systemId + '/cruiseSW/' + this.cancelCodeId
            );
          },
          // CruiseSW情報取得(要求)(GET API) 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.CNC,
              '/netApps/' + this.netAppId + '/systems/' + this.systemId + '/cruiseSW/' + this.cancelCodeId + '/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_CNC_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_CNC_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_CNC_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_CNC_COMPLETED:
              switch (response.data.user_data.result) {
                case 'ok':
                  // Cruise Sw確認画面を閉じて、キャンセルコード読み出し処理を実行
                  this.modalCruise = false;
                  await this.execute();
                  break;
                case 'ng':
                default:
                  // 画面を表示したまま通信終了
                  break;
              }
              break;
            case config.STATUS_CNC_FAILED:
            default:
              // 画面を表示したまま通信終了
              break;
          }
        }
      } finally {
        this.processingCruiseSW = false;
      }
    },

    /**
     * CRUISE SW確認画面を表示する
     */
    openCruiseModal() {
      this.modalCruise = true;
    },

    /**
     *CRUISE SW確認画面を閉じる、キャンセルコード一覧画面に遷移する 
     */
    closeCruiseModal() {
      this.modalCruise = false;
      this.$emit('close-result');
    },

    /* END Cruise SW用の関数一覧 */

    /**
     * ステータス(キャンセルコード)独自ソート
     */
    sortStatus(param) {
      if (!param.data) {
        return null;
      }

      const resultItems = util.sortItems(param.data, 'no', param.sortDir);
      return resultItems;
    },

    /**
     * 説明・理由独自ソート
     */
    sortDescription(param) {
      if (!param.data) {
        return null;
      }

      // 結果リスト
      let resultItems = [];
      // 指定外コードリスト
      const unspecifiedList = [];
      // hyphenリスト
      const hyphenList = [];
      // キャンセルコード割り当て有りリスト
      let descriptionLists = [];
      param.data.forEach(element => {
        if (element.descriptionKey.indexOf('message.status_vehicle_dtc_description_unspecified') > -1) {
          unspecifiedList.push(element);
        }
        if (element.descriptionKey.indexOf('message.common_hyphen') > -1) {
          hyphenList.push(element);
        }
        // キャンセルコードの説明かどうかを判定
        if (element.descriptionKey.indexOf('cnc') > -1) {
          descriptionLists.push(element);
        }
      });

      descriptionLists = util.sortItems(descriptionLists, 'description', param.sortDir);

      // 昇順の場合
      if (param.sortDir === config.ASC) {
        resultItems = descriptionLists.concat(unspecifiedList);
        resultItems = resultItems.concat(hyphenList);
        return resultItems;
      }
      // 降順の場合
      else {
        resultItems = hyphenList.concat(unspecifiedList);
        resultItems = resultItems.concat(descriptionLists);
        return resultItems;
      }
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.systemES.isExec = false;
      this.systemADAS.isExec = false;
      alert.showError(this, null, this.$t('individual.error_communication_error'), () => {
        // ファイルエクスポート・ドロップダウン非活性化
        this.measuredId = undefined;
        this.systemES.isActiveDropdown = false;
        this.systemADAS.isActiveDropdown = false;
      });
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result バリデーション結果
    */
    validateErrorResult(result) {
      this.systemES.isExec = false;
      this.systemADAS.isExec = false;
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /**
     * DIDのテストデータ出力を行う
     */
    didTestDataExport() {
      const ffd = this.$refs.ffd_modal.getTestData();
      const test = this.createFFDTestData(this.ffdTableItems, ffd.items);
      // テストdataを生成する
      // 独自のsortIDでソート
      test.info.sort((a, b) => {
        if (a.sortId < b.sortId) return -1;
        if (a.sortId > b.sortId) return 1;
        return 0;
      });
      // データモニター表示順でソート
      test.info.sort((a, b) => {
        if (a.monitor_order < b.monitor_order) return -1;
        if (a.monitor_order > b.monitor_order) return 1;
        return 0;
      });
      // 独自のsortID削除
      test.info.forEach(element => {
        delete element.sortId;
      });

      if (test.info.length > 0) {
        const csvArray = [[], [], []];
        ffd.items.forEach(ffdData => {
          csvArray[0].push(this.$t(ffdData.item));
          csvArray[1].push(this.$t(ffdData.unit));
          csvArray[2].push(ffdData[this.ffdTableItems[0].ffd_save_order]);
        });

        let csvData = '';
        csvArray.forEach(a => {
          const row = a.join(',');
          csvData += row + '\r\n';
        });
        const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const csvBlob = new Blob([bomFormatData, csvData],
          {
            type: 'text/csv;charset=utf-8',
          });
        const csvLink = document.createElement('a');
        csvLink.href = URL.createObjectURL(csvBlob);
        csvLink.download = ('{0}_DID_FRONT.csv').format(this.systemId); // 出力するファイルの名前
        csvLink.click();
        csvLink.remove();

        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DID_FRONT.json').format(this.systemId); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    /**
     * FFD のテストデータ作成を行う
     * @param {object} originalData 元のデータ
     * @param {object} tableData テストデータ
     * @returns 成形後のテストデータ
     */
    createFFDTestData(originalData, tableData) {
      const result = { info: [] };

      // 優先して最新(確定)のデータのみ取得する。
      const currentData = originalData;

      tableData.forEach(element => {
        const keyId = this.removeResourceKey(element.item);
        const index = currentData.findIndex(item => item.id === keyId);
        if (index === -1) {
          logWrapper.log('ID not found in current data.', keyId);
        }
        else {
          let keyIndex = 0;
          // 10個のキー名までチェックする。
          for (let index = 0; index < 10; index++) {
            keyIndex = String(index);
            if (util.isKeyExists(element, keyIndex)) {
              // keyが存在した場合は処理終了
              break;
            }
          }
          const valueKey = 'value_' + keyIndex;
          const resourceIdKey = 'resouceId_' + keyIndex;

          // テストデータは検出時のみを取得する。
          const findData = currentData[index];

          let sortId = "";
          const keyUnderSplit = keyId.split('_');
          if (keyUnderSplit.length > 1) {
            const second = keyUnderSplit[1].padStart(2, '0');
            sortId = keyUnderSplit[0] + '_' + second;
          }
          if (keyUnderSplit.length > 2) {
            const covertNumber = Number(keyUnderSplit[2]);
            if (!isNaN(covertNumber)) {
              const third = keyUnderSplit[2].padStart(covertNumber, '0');
              sortId = sortId + '_' + third;
            }
          }

          const testData = {
            id: keyId,
            sortId: sortId,
            unit: this.removeResourceKey(element.unit),
            digits_after_decimal: findData.digits_after_decimal,
            data_type: findData.data_type,
            value: String(this.roundValue(element[valueKey])),
            value_resource_id: this.removeResourceKey(element[resourceIdKey]),
            monitor_order: findData.monitor_order
          };
          result.info.push(testData);
        }
      });
      return result;
    },

    /**
     * i18n用文字列の先頭を削除する
     * @param {string} resourceId リソースID
     * @returns メッセージのキー
     */
    removeResourceKey(resourceId) {
      let result = "";
      // 設定されていない場合は""文字列で戻す
      if (!resourceId) {
        return result;
      }
      const resources = resourceId.split('.');
      if (resources.length > 0) {
        result = resources[1];
      }
      return result;
    },

    /**
     * 小数点以下第10位に変換する
     * @param {*} value 数値
     * @returns 変換後の小数
     */
    roundValue(value) {
      let result = value;
      if (value) {
        if ((typeof value) === "number") {
          result = value.toFixed(10);
        }
      }
      return result;
    },

    /**
     * キャンセルコード情報をCSVエクスポートする
     */
    async csvExport() {
      this.processing = true;
      const fileInfo = {};
      let resultInfo = {};
      // 行のフォーマット
      resultInfo = this.cancelCodeResultItems.map(item => {
        return {
          ...item,
          lksmode: this.$t(item.lksmode),
          ffd: item.buttonVisible ? this.$t('message.available_ffd') : this.$t('message.no_ffd')
        };
      });

      // 列のフォーマット
      const igOnCntVar = util.mkHeaderValue(this.resultResponse.current_igon_time);
      const igOnCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igOnCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnCntVar;
      const igOnTimeVar = util.mkHeaderValue(this.resultResponse.current_igon_mill_sec);
      const igOnTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igOnTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnTimeVar;
      const igCntVar = util.mkHeaderValue(this.resultResponse.current_igon_time);
      const igCnt = this.$t('message.header_vehicle_dtc_table_igcounter');
      const igCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igCntVar;
      const absoTimeVar = util.mkHeaderValue(util.convertLocalDateTime(this.resultResponse.current_absolute_time));
      const absoTime = this.$t('individual.label_cnc_absolute_time');
      const absoTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + absoTimeVar;
      fileInfo.column = this.cancelCodeResultColumns.map(column => {
        switch (column.name) {
          case 'igonCount':
            column.label = igOnCnt + " " + igOnCounterValue;
            break;
          case 'igonTime':
            column.label = igOnTime + " " + igOnTimeValue;
            break;
          case 'igCounter':
            column.label = igCnt + " " + igCounterValue;
            break;
          case 'absoluteTime':
            column.label = absoTime + " " + absoTimeValue;
            break;
          default:
        }
        return column;
      });

      // VINデータのフォーマット
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}","${this.vehicleInfo.vehicle.vin.vin}"\n`;

      // 出力形式の設定
      const headers = fileInfo.column.map(column => {
        if (column.name === 'igonCount' || column.name === 'igonTime' || column.name === 'igCounter' || column.name === 'absoluteTime') {
          return { id: column.name, title: column.label };
        } else {
          return { id: column.name, title: this.$t(column.label) };
        }
      });

      // 説明・故障部位のエスケープ処理
      fileInfo.record = util.escapeDoubleQuotation(resultInfo, 'description');

      let endPoint = '';
      let measuredDataName = '';

      if (this.projectId !== undefined && this.measuredId !== undefined) {
        try {
          this.processing = true;
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.projectId + '/' + this.measuredId;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, ApiService.CNC, endPoint, this.operationScreen);
        } finally {
          this.processing = false;
        }
      }
      const fileName = getCsvFileName(this.$t('individual.individual_diagnosis_function_cancel_code'), measuredDataName, this.vehicleInfo.vehicle.vin.vin);

      // CSVファイルエクスポート処理
      const data = vinHeader + util.createCsvData(headers, fileInfo.record);

      // CSVファイルエクスポート処理
      util.csvFileExport(data, fileName);
    },

    /**
     * プルダウンを変更した際の処理(ES)
     * @param {string} val プルダウンリストにて選択した機能
     */
    changeCancelCodeES(val) {
      // 変更したIDを取得
      this.systemES.selectedId = val;
      this.measuredId = this.systemES.resultES.find(e => e.id === this.systemES.selectedId).measuredId;
      this.updateTableES();
      this.updateColumnsES();
    },

    /**
     * プルダウンを変更した際の処理(ADAS)
     * @param {string} val プルダウンリストにて選択した機能
     */
    changeCancelCodeADAS(val) {
      // 変更したIDを取得
      this.systemADAS.selectedId = val;
      this.measuredId = this.systemADAS.resultADAS.find(e => e.id === this.systemADAS.selectedId).measuredId;
      // ADAS2対象はADAS2用の結果テーブル、それ以外はADAS1用の結果テーブルを表示
      if (isAdas2CancelCode(this.systemADAS.selectedId)) {
        this.updateTableADAS2();
        this.updateColumnsADAS2();
        return;
      } else {
        this.updateTableADAS1();
        this.updateColumnsADAS1();
        return;
      }
    },

    /**
     * キャンセルコードの多言語変換の一覧取得
     * @param {Array} menuResponse メニュー一覧
     * @param {string} systemId システム ID
     */
    getPullDownList(menuResponse, systemId) {
      // 多言語変換リストの取得
      return menuResponse.map(item => {
        const i18nCncMenuKey = `cnc${systemId}.${item.id}`;
        const key = `${i18nCncMenuKey}.menu_title`;
        return {
          cancel_code_id: item.id,
          sort_id: item.sort_id,
          menu_title: this.$te(key) ? this.$t(key) : undefined,
        };
      }).sort((a, b) => {
        // sort_id(表示順) 要素でソートする
        return a.sort_id - b.sort_id;
      });
    }
  },

  created() {
    // イベントログのページビューカウント
    eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_CNC);

    this.systemId = individualDiagnose.getCurrentSystemId(this);
    this.projectId = this.vehicleInfo.vehicle.project.id;
  },

  async mounted() {
    // システムがエンジンか判定
    if (DiagSystemUtils.isEngineByAbbreviationId(getAbbrSysName(this.systemId))) {
      // CRUISE SW確認画面
      this.openCruiseModal();
    } else if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(this.systemId))) {
      this.systemES.pullDownList = this.getPullDownList(this.functionList, this.systemId);
      this.systemES.selectedId = this.cancelCodeId;
      // 念のため初期化(ドロップダウン活性化)
      this.systemES.isActiveDropdown = true;

      // データ読み出しとキャッシュクリア
      this.mountedLogic();
    } else if (DiagSystemUtils.isAdasEcuByAbbreviationId(getAbbrSysName(this.systemId))) {
      this.systemADAS.pullDownList = this.getPullDownList(this.functionList, this.systemId);
      this.systemADAS.selectedId = this.cancelCodeId;
      // 念のため初期化(ドロップダウン活性化)
      this.systemADAS.isActiveDropdown = true;

      // データ読み出しとキャッシュクリア
      this.mountedLogic();
    } else {
      // データ読み出しとキャッシュクリア
      this.mountedLogic();
    }
  },

  beforeUnmount() {
    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // onkeydown の再登録
      document.onkeydown = (event) => {
        return util.checkSSM5ValidCharacters(event);
      };
    }
  }
};
